<script lang="ts">
  import { AnchorInline } from '$lib/components/anchor';
  import { PageLayout } from '$lib/components/page';
  import { TextNotice } from '$lib/components/text';
  import { ExcelNav } from '$lib/features/excel';
  import { AppPath } from '$lib/features/app';
</script>

<PageLayout>
  <svelte:fragment slot="sidebarLeft">
    <ExcelNav />
  </svelte:fragment>

  <TextNotice icon="triangle-alert" variant="variant-soft-warning" font="text-sm" margin="mb-6">
    Recomendamos o uso da nova ferramenta de <AnchorInline href={AppPath.OFFICE_BULK} label="Consulta em Massa" />,
    disponível direto no navegador e com exportação para Excel.
  </TextNotice>

  <slot />
</PageLayout>
